var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('info-action-button',{attrs:{"label":_vm.label,"icon":_vm.icon,"color":_vm.done ? _vm.$theme.primaryColor : null,"border-color":_vm.done ? _vm.$theme.primaryColor : null,"title":_vm.title,"width":112},on:{"click":_vm.toggle}})}
var staticRenderFns = []

export { render, staticRenderFns }